import { render, staticRenderFns } from "./customCascader.vue?vue&type=template&id=08c77259&"
import script from "./customCascader.vue?vue&type=script&lang=ts&"
export * from "./customCascader.vue?vue&type=script&lang=ts&"
import style0 from "./customCascader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports